export function LogoMark({ size = 40, className = "" }) {
  // Two opposing arrows: top row exits right (OUT), bottom row enters left (IN).
  // Orange arrows on a hard black frame — reads instantly as "flow both ways".
  return (
    <svg
      viewBox="0 0 56 56"
      width={size}
      height={size}
      className={className}
      aria-label="Out & In logo"
      role="img"
    >
      <rect x="1.5" y="1.5" width="53" height="53" fill="none" stroke="currentColor" strokeWidth="3" />
      {/* OUT — top row, points right, exits the frame */}
      <g fill="#FF5A1F">
        <rect x="8" y="12" width="26" height="8" />
        <polygon points="34,8 48,16 34,24" />
      </g>
      {/* IN — bottom row, points left, enters the frame */}
      <g fill="currentColor">
        <rect x="22" y="36" width="26" height="8" />
        <polygon points="22,32 8,40 22,48" />
      </g>
    </svg>
  );
}

export default LogoMark;
